// extracted by mini-css-extract-plugin
module.exports = {"badges":"Badges_badges__B6uhw","badge":"Badges_badge__1r1EX","button":"Badges_button__ebFzd","title":"Badges_title__cRkFr"};